/* eslint-disable react/prop-types */
import { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Link, Redirect, withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import Input from './Part/Input.jsx';
import Message from './Part/Message.jsx';
import iconPassword from './icons/lock.svg';
import { FormattedMessage, injectIntl } from 'react-intl';
import apiService, { logout } from '../services/axiosAuth';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { logout as logoutAction } from '../reducers/authActions';

class ChangePasswordForm extends Component {
  state = {
    error: null,
    success: null,
    info: null,
    redirect: false,
    showMessage: false,
  };

  componentDidMount() {
    apiService
      .post(`/login/reset-password-sms?hash=${this.props.match.params.hash}`)
      .then(() => {
        this.setState({
          info: this.props.intl.formatMessage({ id: 'Auth sms is sent.' }),
          showMessage: true,
        });
      })
      .catch((e) => {
        if (e.response.status === 400) {
          this.setState({
            error: this.props.intl.formatMessage({
              id: 'Hash is expired, reset password once again',
            }),
            showMessage: true,
          });
        } else {
          this.setState({
            error: this.props.intl.formatMessage({
              id: 'Something went wrong, try again later.',
            }),
            showMessage: true,
          });
        }
      });
  }

  submit = (values) => {
    this.setState({
      error: null,
      success: null,
      showMessage: false,
    });

    apiService
      .patch('/login/change-password', {
        hash: this.props.match.params.hash,
        password: values.password,
        smsCode: values.smsPassword,
      })
      .then(() => {
        logout().then(() => {
          this.props.dispatch(logoutAction());
          this.props.history.push({
            pathname: '/login',
            state: {
              success: this.props.intl.formatMessage({
                id: this.props.firstTime ? 'Password is set.' : 'Password is changed.',
              }),
              showMessage: true,
            },
          });
        });
      })
      .catch(() => {
        this.setState({
          error: this.props.intl.formatMessage({
            id: 'Something went wrong, try again later.',
          }),
          showMessage: true,
        });
      });
  };

  hideMessage = () => {
    this.setState({ showMessage: false });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={{ pathname: '/login', state: { afterPassChange: true } }} />;
    }
    const validationSchema = Yup.object().shape({
      password: Yup.string()
        .required(this.props.intl.formatMessage({ id: 'This field is required' }))
        .matches(
          /[A-ZĄĘŁÓŚŻŹĆŃ]/u,
          this.props.intl.formatMessage({
            id: 'Password should have at least one capital letter',
          })
        )
        .matches(
          /\d/u,
          this.props.intl.formatMessage({
            id: 'Password should contain at least one digit',
          })
        )
        .matches(
          /^.{8,64}$/u,
          this.props.intl.formatMessage({
            id: 'Password length should be between 8 and 64',
          })
        )
        .matches(
          /^[0-9A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż!@./#$%^&_\-?,*(){}[\]\\|:";'<>]*$/,
          this.props.intl.formatMessage({
            id: 'Password contains incorrect characters',
          })
        ),
      password2: Yup.string()
        .required(this.props.intl.formatMessage({ id: 'This field is required' }))
        .oneOf([Yup.ref('password'), null], this.props.intl.formatMessage({ id: 'Passwords have to be same' })),
    });

    return (
      <>
        {this.state.error && <Message message={this.state.error} open={this.state.showMessage} onClick={this.hideMessage} type='error' />}
        {this.state.success && (
          <Message message={this.state.success} open={this.state.showMessage} onClick={this.hideMessage} type='success' />
        )}
        {this.state.info && <Message type='info' open={this.state.showMessage} onClick={this.hideMessage} message={this.state.info} />}
        <Formik
          initialValues={{
            password: '',
            password2: '',
            smsPassword: '',
          }}
          validateOnBlur
          validateOnChange
          onSubmit={this.submit}
          validationSchema={validationSchema}
          render={(props) => {
            return (
              <Form>
                <div style={{ paddingTop: '10px' }}>
                  <Link className='login-link' to='/login'>
                    <FormattedMessage id='Back to sign in' />
                  </Link>
                </div>
                <div className='field-box form-styles'>
                  <label>
                    <FormattedMessage id='Sms password' />
                  </label>
                  <br />
                  <Field name='smsPassword' component={Input} value={props.values.smsPassword} type='password' icon={iconPassword} />
                  <ErrorMessage component='div' className='text-danger' name='smsPassword' />
                </div>
                <div className='field-box form-styles'>
                  <label>
                    <FormattedMessage id='New password' />
                  </label>
                  <br />
                  <Field name='password' component={Input} value={props.values.password} type='password' icon={iconPassword} />
                  <ErrorMessage component='div' className='text-danger' name='password' />
                </div>
                <div className='field-box form-styles'>
                  <label>
                    <FormattedMessage id='Repeat password' />
                  </label>
                  <br />
                  <Field name='password2' component={Input} value={props.values.password2} type='password' icon={iconPassword} />
                  <ErrorMessage component='div' className='text-danger' name='password2' />
                </div>
                <div className='login-form-button-wrapper'>
                  <button type='submit' className='login-form-button'>
                    <FormattedMessage id={this.props.firstTime ? 'SET PASSWORD' : 'CHANGE PASSWORD'} />
                  </button>
                </div>
              </Form>
            );
          }}
        />
      </>
    );
  }
}

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state) => state.authReducer)
);

export default enhance(ChangePasswordForm);
